import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ChannelService } from '@app/integration/Channel.service';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { Channel, Integration } from '@product/shared/models/integration';

@Component({
  selector: 'app-product-integrations',
  templateUrl: './product-integrations.component.html',
  styleUrls: ['./product-integrations.component.less'],
})
export class ProductIntegrationsComponent
  extends BaseProductComponent
  implements OnInit
{
  integrations: Integration[] = [];
  isLoading = true;
  @Input() selectedChannels: Set<Channel>=new Set<Channel>();
  @Output() selectionChanged = new EventEmitter();
  constructor(injector: Injector, private channelsService: ChannelService) {
    super(injector);
  }

  ngOnInit() {
    this.getIntegrations();
  }
  getIntegrations() {
    this.subscriptions.push(
      this.channelsService.getIntegrations().subscribe((response) => {
        this.integrations = response.value;
        this.isLoading = false;
      })
    );
  }

  onSelectionChanged(status: boolean, channel: Channel) {
    if (status === true) {
      this.selectedChannels.add(channel);
    } else {
      this.selectedChannels.delete(channel);
    }
    this.selectionChanged.emit(this.selectedChannels);
  }
}
